import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import classnames from 'classnames';
import { Icon, Input } from 'xm-spark';

import styles from './SearchInput.module.scss';

function SearchInput({
  className,
  classes,
  value,
  onClear,
  messages,
  inputRef,
  ...otherProps
}) {
  const ref = useRef(null);
  const dataTestId = otherProps['data-testid'] || 'searchInput';

  return (
    <label className={classnames(styles.SearchInput, className)}>
      <Icon
        type="icon-search"
        className={classnames(styles.Icon, classes.icon)}
      />
      <Input
        className={classnames(styles.Input, classes.input)}
        value={value || ''}
        inputRef={inputRef || ref}
        {...otherProps}
      />
      {!!value && !!onClear && (
        <Icon
          type="icon-cancel"
          role="button"
          onClick={onClear}
          onKeyUp={e => {
            if (e.key === 'Enter') {
              e.preventDefault();
              onClear();
              if (inputRef?.current) {
                inputRef.current.focus();
              } else {
                ref.current?.focus();
              }
            }
          }}
          title={messages.CLEAR || ''}
          className={styles.Clear}
          tabIndex="0"
          data-testid={`${dataTestId}_clear`}
        />
      )}
    </label>
  );
}

SearchInput.displayName = 'SearchInput';

SearchInput.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({
    icon: PropTypes.string,
    input: PropTypes.string,
  }),
  value: PropTypes.string,
  onClear: PropTypes.func,
  messages: PropTypes.shape({
    CLEAR: PropTypes.string,
  }),
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({})]),
};

SearchInput.defaultProps = {
  className: null,
  classes: {},
  value: null,
  onClear: null,
  messages: {},
  inputRef: null,
};

export default SearchInput;
